import {
    addToChainBefore,
    createHandlerChainRunner,
    Handler,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import {
    addWishListToCart as addWishListToCartApi,
    AddWishListToCartApiParameter,
} from "@insite/client-framework/Services/CartService";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { CartLineCollectionModel } from "@insite/client-framework/Types/ApiModels";
import { PopulateApiParameter, chain } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddWishListToCart";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";
import { setShowRequisitionCartDisclaimer } from "@tKgpco/Handlers/RequistionCart/Handlers/showRequisitionCartDisclaimer";

type Parameter = {
    apiParameter: AddWishListToCartApiParameter;
} & HasOnSuccess<CartLineCollectionModel>;

type Props = {
    apiParameter: AddWishListToCartApiParameter;
    apiResult: CartLineCollectionModel;
    errorMessage: string;
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameterCustom: HandlerType = props => {
    const state = props.getState() as CustomApplicationState;

    if (state.KGPState.RequistionCartStore.isRequistionCartPresent) {
        props.dispatch(setShowRequisitionCartDisclaimer({ showDisclaimerForRequistionCart: true }));
        return false;
    }
};

addToChainBefore(chain, PopulateApiParameter, PopulateApiParameterCustom);
